import { Logo } from "@dashboard/assets/icons";
import { MobileViewStyles } from "./mobile-view.styled";
import { useTranslation } from "react-i18next";
import { theme } from "@dashboard/assets/theme";

export const MobileView = () => {
  const imageMobileView =
    "https://assets.domun.co/prod/web/landing/sumer-app-mobile.webp";
  const { t } = useTranslation();
  return (
    <MobileViewStyles>
      <div className="mobile-container">
        <div className="logo-mobile">
          <Logo svgColor={theme.colors.black} />
        </div>
        <div className="body-mobile">
          <div className="header-texts">
            <h1>{t("start")}</h1>
            <p>{t("access")}</p>
          </div>
          <div className="icons">
            <span className={"icon icon-android"} />
            <span className={"icon icon-apple"} />
          </div>
          <a
            href="https://link.sumerlabs.com/sDH5/download"
            target="_blank"
            rel="noreferrer"
          >
            <button className="button-mobile-view" onClick={() => {}}>
              <span className="button-text">{t("downloadApp")}</span>
            </button>
          </a>
        </div>
      </div>
      <div className="mobile-image-container">
        <img src={imageMobileView} alt="sumer-app-download" />
      </div>
    </MobileViewStyles>
  );
};
